import { render, staticRenderFns } from "./accidentBasicData.vue?vue&type=template&id=da57291a&scoped=true"
import script from "./accidentBasicData.vue?vue&type=script&lang=js"
export * from "./accidentBasicData.vue?vue&type=script&lang=js"
import style0 from "./accidentBasicData.vue?vue&type=style&index=0&id=da57291a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da57291a",
  null
  
)

export default component.exports